import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=0cc354ec&scoped=true&"
import script from "./DropdownItem.vue?vue&type=script&lang=js&"
export * from "./DropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=0cc354ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc354ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc354ec')) {
      api.createRecord('0cc354ec', component.options)
    } else {
      api.reload('0cc354ec', component.options)
    }
    module.hot.accept("./DropdownItem.vue?vue&type=template&id=0cc354ec&scoped=true&", function () {
      api.rerender('0cc354ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/dropdown/DropdownItem.vue"
export default component.exports